export enum AnalyticsTool {
	booking = 'booking',
}

export enum AnalyticsCategory {
	booking = 'booking',
	waitlist = 'waitlist',
	banners = 'banners',
}

export enum AnalyticsEvent {
	showPopup = 'show_popup',
	clickAddResource = 'click_add_resource',
	addResourceStep1 = 'add_resource_step1',
	addResourceStep2 = 'add_resource_step2',
	addResourceFinish = 'add_resource_finish',
	acceptAgreement = 'accept_agreement',
}

export enum AnalyticsType {
	showPopup = 'show_popup',
	clickAddResource = 'click_add_resource',
}

export enum AnalyticsCSection {
	booking = 'booking',
	crm = 'crm',
	mainMenu = 'main_menu',
}

export enum AnalyticsElement {
	addButton = 'add_button',
}

export enum AnalyticsCSubSection {
	accept = 'accept',
	deny = 'deny',
}
